import { IS_DEV, IS_STAGING } from '../constants';
import { DEV_SSO_ROOT, STAGING_SSO_ROOT, PROD_SSO_ROOT } from '../constants/sso';
import { PROVIDER_FNAC, PROVIDER_DARTY } from '../services/authentication/constants';

function getSsoRoot() {
    if (IS_DEV) {
        return DEV_SSO_ROOT;
    } else if (IS_STAGING) {
        return STAGING_SSO_ROOT;
    } else {
        return PROD_SSO_ROOT;
    }
}

/**
 * URL de démarrage du flux SSO d'un fournisseur (GET /api/sso/{provider}/start).
 * Lien top-level (pas d'AJAX) : le back redirige vers la page de login du fournisseur
 * puis, au callback, vers le front (?tk=xxx&provider=... en succès, ?error=X sinon).
 * Contrat identique pour Fnac et Darty.
 */
export function getSsoLoginUrl(provider) {
    return `${getSsoRoot()}/${provider}/start`;
}

export function getFnacLoginUrl() {
    return getSsoLoginUrl(PROVIDER_FNAC);
}

export function getDartyLoginUrl() {
    return getSsoLoginUrl(PROVIDER_DARTY);
}

/**
 * Le back renvoie des URLs absolues (baseUrl + chemin) dans les réponses d'authentification
 * (SsoDecodeTokenDto) : on les ramène à un chemin relatif utilisable par le routeur.
 */
export function toRelativeUrl(url) {
    return url ? url.replace(/^https?:\/\/[^/]+/, '') : '';
}

// Paramètre ?redirect=, non encodé : tout ce qui le suit fait partie de l'URL
export function extractRedirectParam(search) {
    const matches = /[?&]redirect=(.*)$/.exec(search || '');
    if (!matches) {
        return null;
    }

    try {
        return matches[1].includes('://') ? matches[1] : decodeURIComponent(matches[1]);
    } catch (e) {
        return null;
    }
}

// URL absolue http(s) du même domaine que l'app, sinon null (pas de redirection ouverte)
export function toSameOriginUrl(value) {
    if (!value || !/^https?:\/\//i.test(value)) {
        return null;
    }

    try {
        const url = new URL(value);
        return url.origin === window.location.origin ? url.href : null;
    } catch (e) {
        return null;
    }
}

/**
 * Extrait le token SSO du paramètre ?tk= de l'URL de succès renvoyée par le back.
 */
export function extractSsoToken(url) {
    const matches = /[?&]tk=([^&]+)/.exec(url || '');
    return matches ? matches[1] : null;
}

/**
 * Extrait l'origine d'authentification (&provider=fnac|darty) apposée par le back
 * sur l'URL de succès, à relayer dans le body de /auth/login.
 */
export function extractSsoProvider(url) {
    const matches = /[?&]provider=([^&]+)/.exec(url || '');
    return matches ? matches[1] : null;
}



// WEBPACK FOOTER //
// ./src/utils/ssoUtil.js